import FormBuilderCheckbox from "./Component/FormBuilderCheckbox";
import FormBuilderSelection from "./Component/FormBuilderSelection";
import FormBuilderTextInput from "./Component/FormBuilderTextInput";
import FormBuilderRow from "./Layout/FormBuilderRow";
import FormBuilderSection from "./Layout/FormBuilderSection";
import FormBuilderFieldBuilder from "./lib/FormBuilderFieldBuilder";
import { formBuilderDefinedRules as rules } from "./lib/FormBuilderRules";

/**
 * @typedef {Object} FormBuilderParams
 * @property {number} formItemColGap
 * @property {number} formItemRowGap
 * @property {React.CSSProperties} formItemStyle
 * @property {string} formSectionLeftPadding
 * @property {number} formSectionTitleTopPadding
 */

/**
 * Form builder params
 * @type {FormBuilderParams}
 */
export const formBuilderParams = {
  formItemColGap: 2,
  formItemRowGap: 2,
  formItemStyle: {
    flexGrow: 1,
    flexBasis: "300px",
  },
  formSectionLeftPadding: "0 0 0 24px",
  formSectionTitleTopPadding: 1,
};

export const FormBuilder = {
  Section: FormBuilderSection,
  Row: FormBuilderRow,

  TextInput: FormBuilderTextInput,
  Checkbox: FormBuilderCheckbox,
  Selection: FormBuilderSelection,
  buildFields: FormBuilderFieldBuilder,

  rules: rules,
};
